var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VMSMapDetail'),_c('br'),(_vm.owner !== 'psd')?_c('VMSVideo'):_vm._e(),(_vm.owner === 'psd')?_c('VMSVideoPSD'):_vm._e(),_c('br'),(_vm.check)?_c('VMSTable'):_vm._e(),_c('br'),(_vm.check)?_c('VMSGraph'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }